import {useEffect} from 'react'
import {lerp} from '@colonist/utils'
import {Sound} from '../utils/sound'

const SECONDS_LEFT_BEFORE_TICKING_SOUND = 5

export function useTimerLowTime(timeLeftInSeconds: number, isSoundEnabled: boolean): boolean {
    const isLowTime = timeLeftInSeconds <= SECONDS_LEFT_BEFORE_TICKING_SOUND

    useEffect(() => {
        if(!isSoundEnabled || !isLowTime) return

        const isFirstReminder = timeLeftInSeconds == SECONDS_LEFT_BEFORE_TICKING_SOUND
        if(isFirstReminder) Sound.playSound(Sound.SoundType.FirstReminder, 0.6, 1.0)

        const progress = (SECONDS_LEFT_BEFORE_TICKING_SOUND - timeLeftInSeconds) / SECONDS_LEFT_BEFORE_TICKING_SOUND

        const minimumVolume = 1.0
        const maximumVolume = 1.2
        const volume = lerp(minimumVolume, maximumVolume, progress)

        const minimumPitch = 1.0
        const maximumPitch = 1.5
        const pitch = lerp(minimumPitch, maximumPitch, progress)

        Sound.playSound(Sound.SoundType.ClockTick, volume, pitch)
    }, [timeLeftInSeconds, isSoundEnabled, isLowTime])

    return isLowTime
}
